// ===================================================
// 募集期生情報の管理ファイル
// 期生・開催時期・定員を変更する場合はここだけ編集してください
// ===================================================

export interface CohortInfo {
  /** 募集中の期（例: '4期生'） */
  cohortLabel: string;
  /** 開催開始年月（例: '2026年4月'） */
  startMonth: string;
  /** 定員人数（例: 5） */
  capacity: number;
}

export const cohortInfo: CohortInfo = {
  cohortLabel: '4期生',
  startMonth: '2026年4月',
  capacity: 5,
};
